import { Modal } from 'semantic-ui-react';
import { TaskExecutionsCreationSchemaType, TaskIdType } from '../../../../schemas/task.schemas';
import { CompanyType } from '../../../../types/company.types';
import TaskExecutionsCreateForm from '../taskExecutionsCreateForm';

type TaskExecutionModalPropsType = {
    taskId: TaskIdType;
    open: boolean;
    onCancel: () => void;
    onSave: (data: TaskExecutionsCreationSchemaType) => void;
    companies: CompanyType[];
};

function TaskExecutionsCreateModal({ taskId, open, onCancel, onSave, companies }: TaskExecutionModalPropsType) {
    return (
        <Modal open={open} onClose={onCancel}>
            <Modal.Content>
                <TaskExecutionsCreateForm taskId={taskId} onSave={onSave} onCancel={onCancel} companies={companies} />
            </Modal.Content>
        </Modal>
    );
}

export default TaskExecutionsCreateModal;
